import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { PreInitSettingsService } from 'src/app/core/services/settings/pre-init-setting.service';
import { GTMLoginEvents } from 'src/app/model/google-tag-manager/api-status';


@Component({
  selector: 'app-custom-okta-callback',
  template: '<div></div>'  // OktaCallbackComponent requires a template, but we won't use it directly
})
export class CustomOktaCallbackComponent implements OnInit {

  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
  private preInitSettingsService: PreInitSettingsService,
  private http: HttpClient,
  private googleAnalyticsService: GoogleAnalyticsService,
  private router: Router) {

    // This works fine for PKCE flow but its not longer needed; but keeping it if in case
    // okta modules doesnt work as expected with different versions
    // or if are forced to use PKCE mode then this will work

  }

  async ngOnInit() {
    this.handleAuthCallback();
  }

  private handleAuthCallback(): void {
    // Extract the authorization code from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    if (code) {
      this.exchangeCodeForToken(code);
    } else {
      // Handle the case where there's no code
      console.error('Authorization code not found in URL');
      this.router.navigate(['/error']); // Redirect to an error page or handle accordingly
    }
  }

  private async exchangeCodeForToken(code: string) {
    let okta = this.preInitSettingsService.getSettings().okta;
    let issuer = okta.issuer;

    let clientId = okta.clientId;
    let tokenEndpoint = issuer + '/v1/token';
    const storageItem = localStorage.getItem('okta-pkce-storage');
    const { codeVerifier, redirectUri } = JSON.parse(storageItem);
    const body = new HttpParams()
      .set('client_id', clientId)
      .set('redirect_uri', redirectUri)
      .set('grant_type', 'authorization_code')
      .set('code', code)
      .set('code_verifier', codeVerifier);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    this.http.post(tokenEndpoint, body.toString(), { headers })
      .subscribe(
        async (response: any) => {

          var tokenResponse : any = {}
                          , expiresIn = response.expires_in
                          , tokenType = response.token_type
                          , accessToken = response.access_token
                          , idToken = response.id_token
                          , refreshToken = response.refresh_token;

          if (accessToken) {
            var decodedAccessToken = this.oktaAuth.token.decode(accessToken);
            tokenResponse.accessToken = {
              value: accessToken,
              accessToken: accessToken,
              claims: decodedAccessToken.payload,
              expiresAt: Number(expiresIn) + Math.floor(Date.now() / 1000),
              tokenType: tokenType,
              scopes: okta.scopes,
              authorizeUrl: okta.issuer + "/v1/authorize",
              userinfoUrl: okta.issuer + "/v1/userinfo"
            };
          }

          if (refreshToken) {
            tokenResponse.refreshToken = {
              value: refreshToken,
              refreshToken: refreshToken,
              expiresAt: Number(expiresIn) + Math.floor(Date.now() / 1000),
              scopes: okta.scopes,
              tokenUrl: okta.issuer + "/v1/token",
              authorizeUrl: okta.issuer + "/v1/authorize",
              userinfoUrl: okta.issuer + "/v1/userinfo"
            };
          }

          if (idToken) {
            var decodedIdToken = this.oktaAuth.token.decode(idToken);
            tokenResponse.idToken = {
              value: idToken,
              idToken: idToken,
              claims: decodedIdToken.payload,
              expiresAt: decodedIdToken.payload.exp,
              authorizeUrl: okta.issuer + "/v1/authorize",
              issuer: okta.issuer,
              clientId: clientId
            };
          }

          localStorage.setItem('okta-token-storage', JSON.stringify(tokenResponse));
          let user = await this.oktaAuth.getUser();
          localStorage.setItem('okta-user', JSON.stringify(user));
          window.location.href = '/dashboard';
        },
        (error) => {
          console.error('Error exchanging code for token:', error);
          this.router.navigate(['/login']); // Redirect to an error page or handle accordingly
        }
      );
  }

}
